import axiosInstance from "@/plugins/axios";

export const actions = {
    async fetchBooks(filters = {}) {
        this.booksLoading = true;
        try {
            const params = { include: 'coverImage', orderBy: 'id', sortedBy: 'asc' };
            if (filters && typeof filters === 'object') {
                if (filters.published != null) params.published = filters.published ? 1 : 0;
                if (filters.approval_status != null) params.approval_status = filters.approval_status;
                if (filters.audience != null) params.audience = filters.audience;
                if (filters.premium != null) params.premium = filters.premium ? 1 : 0;
                if (filters.status != null) params.status = filters.status;
                if (filters.name != null && String(filters.name).trim()) params.name = filters.name.trim();
                if (filters.author_name != null && String(filters.author_name).trim()) params.author_name = filters.author_name.trim();
                if (filters.language_id != null && filters.language_id !== '') params.language_id = filters.language_id;
            }
            const response = await axiosInstance.get('/api/books', { params });
            this.books = response.data.data;
            return response.data.data;
        } catch (error) {
            console.error('Error fetching books:', error);
            throw error;
        } finally {
            this.booksLoading = false;
        }
    },

    async fetchBook(id, include = 'author,tags,coverImage') {
        try {
            const url = include ? `/api/books/${id}?include=${include}` : `/api/books/${id}`;
            const response = await axiosInstance.get(url);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching book:', error);
            throw error;
        }
    },

    async fetchPage(id) {
        try {
            const response = await axiosInstance.get(`/api/pages/${id}?include=media`);
            this.selectedPage = response.data.data;
            return response.data.data; // Return the fetched page data
        } catch (error) {
            console.error('Error fetching page:', error);
            throw error;
        }
    },

    async addPage(pageData) {
        try {
            const response = await axiosInstance.post('/api/pages', pageData);
            this.pages.push(response.data.data);
            return response.data.data; // Return the added page data
        } catch (error) {
            console.error('Error adding page:', error);
            throw error;
        }
    },

    async updatePage(id, pageData) {
        try {
            const response = await axiosInstance.put(`/api/pages/${id}`, pageData);
            const index = this.pages.findIndex((page) => page.id === id);
            if (index !== -1) {
                this.pages[index] = response.data.data;
            }
            return response.data.data; // Return the updated page data
        } catch (error) {
            console.error('Error updating page:', error);
            throw error;
        }
    },

    async deletePage(id) {
        try {
            await axiosInstance.delete(`/api/pages/${id}`);
            this.pages = this.pages.filter((page) => page.id !== id);
            // Optionally return some status or confirmation
        } catch (error) {
            console.error('Error deleting page:', error);
            throw error;
        }
    },

    async attachContentFeedToBook(id, contentFeedId) {
        try {
            const response = await axiosInstance.put(`/api/books/${id}/content-feeds/${contentFeedId}/attach`, {model_type: 'Laraplate\\Entities\\Book\\Models\\Book'});
            return response.data.data;
        } catch (error) {
            console.error('Error fetching page:', error);
            throw error;
        }
    },

    async createBook(payload) {
        try {
            const body = {};
            const allowed = [
                'name', 'language_id', 'author_id', 'description', 'status', 'edition',
                'isbn', 'is_premium', 'is_published', 'publication_date',
                'references', 'comments_enabled', 'approval_status',
                'notes', 'tags', 'audience', 'cover_position'
            ];
            allowed.forEach((key) => {
                if (payload[key] !== undefined && payload[key] !== null) body[key] = payload[key];
            });
            const response = await axiosInstance.post('/api/books', body);
            const book = response.data.data ?? response.data;
            if (book?.id) this.books = [book, ...(this.books || [])];
            return book;
        } catch (error) {
            console.error('Error creating book:', error);
            throw error;
        }
    },

    async duplicateBook(id, payload = {}) {
        try {
            const body = {};
            if (payload.name != null && String(payload.name).trim()) body.name = String(payload.name).trim();
            const response = await axiosInstance.post(`/api/books/${id}/duplicate`, body);
            return response.data?.data ?? response.data;
        } catch (error) {
            console.error('Error duplicating book:', error);
            throw error;
        }
    },

    async updateBook(id, payload) {
        try {
            const body = {};
            const allowed = [
                'name', 'language_id', 'author_id', 'description', 'status', 'edition',
                'isbn', 'is_premium', 'is_published', 'publication_date',
                'references', 'comments_enabled', 'approval_status',
                'notes', 'tags', 'audience', 'cover_position'
            ];
            allowed.forEach((key) => {
                if (payload[key] !== undefined && payload[key] !== null) body[key] = payload[key];
            });
            const response = await axiosInstance.put(`/api/books/${id}`, body);
            const index = this.books.findIndex((b) => b.id === id);
            if (index !== -1 && response.data?.data) this.books[index] = { ...this.books[index], ...response.data.data };
            return response.data?.data ?? response.data;
        } catch (error) {
            console.error('Error updating book:', error);
            throw error;
        }
    },

    async uploadBookCover(bookId, file, clear = true) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('model_type', 'Laraplate\\Entities\\Book\\Models\\Book');
            formData.append('media_collection', 'cover_image');
            if (clear) formData.append('clear', '1');
            const url = clear ? `/api/books/${bookId}/files?clear=true` : `/api/books/${bookId}/files`;
            const response = await axiosInstance.post(url, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data?.data ?? response.data;
        } catch (error) {
            console.error('Error uploading book cover:', error);
            throw error;
        }
    },
};
